import React, { useState, useRef, useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import store from "../../redux/store";
import { updateGenResponse } from "../../redux/action/genericSurveyAction";
import { savedSuccessFullySurvey } from "../../redux/action/saveAction";
import { Form, Card } from "@deere/ux.uxframe-react";
import { Grid } from "@deere/fuel-react";
import OSButtonsSection from "./OSButtonsSection";
import CustomAlert from "../../components/CustomAlert";
import LeftMenu from "../../components/LeftMenu";
import { handleSaveOS, uploadSurveyFile } from "../../utils/saveSurveyUtils";
import { isSupplierAllowed, getDateFromTimeStamp } from "../../utils/utils";
import { getSectionsWithErrors } from "../../utils/validation";
import { EMPTY_BODY, OS_CONTACT_PARENT_ANS, OS_CONTACT_PARENT } from "../../utils/surveyLiterals";
import { useUserInfo } from "../../providers/userProvider";
import { useTranslation } from "react-i18next";
import { useOktaAuth } from "@okta/okta-react";
import OSSectionPage from "./OSSectionPage";

const OSSurveyPage = ({ survey, setSurvey }) => {
  const userInfo = useUserInfo();
  const { authState } = useOktaAuth();
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState([]);
  const surveySaved = useSelector((state) => state.save.saveSurvey);
  const sections = survey.sections;
  let sectionsTitles = [...sections.map((section, index) => section.description)];
  const [actLink, setActLink] = useState(new Array(sectionsTitles.length).fill(""));
  const sectionsRef = useRef([new Array(sectionsTitles.length)]);
  const location = useLocation();
  const { t } = useTranslation();
  const campaign = store.getState().campaign.campaignAssigned;
  const surveyResponse = useSelector((state) => state.genericSurvey.surveyResponses[survey.code]);
  const dispatch = useDispatch();
  const history = useHistory();
  const [answers, setAnswers] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [title] = useState({
    updatedByName: location && location.state ? location.state.updatedByName : "",
    supplierName: location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName,
    surveyType: location && location.state ? location.state.surveyType : survey.description,
    updatedTs: location && location.state ? location.state.updatedTs : campaign.assignments[0].lastUpdatedTs,
  });

  const handleScroll = useCallback(() => {
    const currentScrollPos = window.pageYOffset;
    let tmpActLink = new Array(sectionsTitles.length).fill("");
    let tmpRefs = [];
    sectionsRef.current.map((section) => {
      if (section) {
        currentScrollPos + 300 >= section.offsetTop ? tmpRefs.push("active") : tmpRefs.push("");
      }
    });
    tmpActLink[tmpRefs.lastIndexOf("active")] = "active";
    setActLink(tmpActLink);
  }, [sectionsTitles.length, location.state]);

  const surveyTitle = () => {
    if (title) {
      if (!title.updatedByName) {
        return (
          <div className="p-2">
            <h1>{title.surveyType}</h1>
            <h5>{title.supplierName} </h5>
            <h5>Due date {getDateFromTimeStamp(new Date(campaign.endDate))}</h5>
          </div>
        );
      } else {
        return (
          <div className="p-2">
            <h1>{title.surveyType}</h1>
            <h5>{title.supplierName}</h5>
            <h5>Due date {getDateFromTimeStamp(new Date(campaign.endDate))}</h5>
            <h5> {` Last saved on ${title.updatedTs} by ${title.updatedByName} `}</h5>
          </div>
        );
      }
    }
    return null;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!survey) {
    return EMPTY_BODY;
  }

  const getOwnershipContacts = (survey, store, answers) => {
    let osContacts = store.getState().genericSurvey.osContactForm;
    let parentCheck = false;
    if (!osContacts) osContacts = [];
    let parentQue;
    for (let i = 0; i < survey.sections.length; i++) {
      let questions = survey.sections[i].questions;
      parentQue = questions.find((que) => que.code === OS_CONTACT_PARENT);
      if (parentQue) break;
    }
    if (parentQue) {
      let parentAns = answers.find((ans) => ans.questionId === parentQue.id);
      if (parentAns && parentAns.answer === OS_CONTACT_PARENT_ANS) {
        parentCheck = true;
      }
    }

    return { contacts: osContacts, parentCheck: parentCheck };
  };

  const handleSubmit = (event) => {
    setIsSubmitted(true);
    const form = event.currentTarget;
    let errorSections = getSectionsWithErrors(form);
    setErrors(errorSections);

    setValidated(true);
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() && errorSections.length <= 0) {
      setIsSubmitted(false);
      setValidated(false);

      let answers = store.getState().genericSurvey.surveyAnswersForm[survey.code];
      let ownershipContact = getOwnershipContacts(survey, store, answers);
      const updByName = location && location.state ? location.state.updatedByName : campaign.updatedByName;
      const supplierName = location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName;
      const surveyType = survey.description;
      handleSaveOS(surveyResponse, answers, campaign, userInfo, authState, ownershipContact)
        .then((responses) => {
          if (responses.length > 0) {
            const res = responses[responses.length - 1];
            if (res.id) {
              let i = 0;
              const selectElement = document.getElementsByClassName("surveyFile");
              for (let inputFile of selectElement) {
                i = i + 1;
                if (inputFile.value !== undefined && inputFile.value !== "") {
                  const cert = inputFile.files[0];
                  const fd = new FormData();
                  fd.append("file", cert);
                  fd.append("content-type", "application/pdf");

                  uploadSurveyFile(fd, campaign, "file" + i, userInfo, authState.accessToken.accessToken)
                    .then((response) => {})
                    .catch((error) => {
                      console.log(error);
                    });
                }
              }
              dispatch(updateGenResponse({ surveyCode: survey.code, surveyResponse: res }));
              history.push({
                pathname: "/review",
                state: {
                  previous: "/survey",
                  survey: survey,
                  updatedByName: updByName,
                  supplierName: supplierName,
                  surveyType: surveyType,
                  campaign: campaign,
                  answers: answers,
                  updatedTs: location && location.state ? location.state.updatedTs : ""
                },
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      window.scrollTo(0, 0);
    }
  };

  const showErrorCard = (
    <>
      <Card className="p-2 mb-2 bg-danger">
        <Card.Body className="uxf-card-body-table">
          <Card.Title className="pb-3 text-white">{t("lbl_error_survey_validation")}</Card.Title>
          {errors.map((error, index) => (
            <div key={index}>
              <li className="text-white">{error}</li>
            </div>
          ))}
        </Card.Body>
      </Card>
      <br />
    </>
  );

  function clearErrors() {
    setValidated(false);
    setErrors([]);
  }

  if (!surveyResponse) {
    return (
      <div>
        <h5>Loading...</h5>
      </div>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        {surveyTitle()}
      </Grid>
      <Grid item xs={12} md={2.5}>
        {actLink.length > 0 && <LeftMenu actLink={actLink} survey={survey} />}
      </Grid>
      <Grid item xs={12} md={9.5}>
        {errors.length > 0 ? showErrorCard : null}
        {surveySaved.variant === "success" ? <CustomAlert accessibilityLabel={surveySaved.variant} variant={surveySaved.variant} title={surveySaved.description} /> : null}
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          {sections
            .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
            .map((section, index) => (
              <div key={index}>
                <div ref={(el) => (sectionsRef.current[index] = el)}>
                  <OSSectionPage section={section} survey={survey} setAnswers={setAnswers} answers={answers} isSubmit={isSubmitted} setIsSubmitted={setIsSubmitted} />
                </div>
                <br />
              </div>
            ))}
          {userInfo && isSupplierAllowed(userInfo.userType) && <OSButtonsSection setSurvey={setSurvey} campaign={campaign} clearFunction={clearErrors} survey={survey} />}
        </Form>
      </Grid>
    </Grid>
  );
};

export default OSSurveyPage;
